import { axiosInstance } from "@/axios/interceptors";

export default {
  // announceList: (data: AnnounceListParam) => axiosInstance.get("/api/member/notice/list", { params: data }),

  noticeList: async (data: any) => {
    return await axiosInstance.get(`noticeboards`, { params: data });
  },
  noticeDetail: async (seq: number) => {
    return await axiosInstance.get(`noticeboards/${seq}`);
  },

  downloadNoticeboardFile(seq: number, index: number, filename: string) {
    return axiosInstance
      .get(`noticeboards/${seq}/download-attach-files/${index}`, {
        responseType: "blob",
      })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename); // You can set the file name here
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
  },
};
